import {
  selectClubImportState,
  selectExtensionSupportsLatestFeatures,
} from "@/redux/clubImport/clubImportSlice";
import { IOS_CLUB_IMPORT_APP_URL } from "@/settings";
import { Trans, useTranslation } from "@repo/shared/i18n";
import { isMacOs } from "react-device-detect";
import { useSelector } from "react-redux";

import { TutorialAlert } from "./TutorialAlert";

type ExtensionOutdatedBannerProps = {
  className?: string;
};

export const ExtensionOutdatedBanner = ({
  className,
}: ExtensionOutdatedBannerProps) => {
  const { t } = useTranslation("clubImport");
  const { extensionEnabledStatus, browser } = useSelector(
    selectClubImportState,
  );
  const extensionSupportsLatest = useSelector(
    selectExtensionSupportsLatestFeatures,
  );

  if (extensionEnabledStatus !== "enabled" || extensionSupportsLatest) {
    return null;
  }

  const isSafariMobile = browser === "iosSafari";

  const chromeDesktopUpdateHint = isMacOs
    ? t("tutorial.extensionOutdated.macHint")
    : t("tutorial.extensionOutdated.windowsHint");

  return (
    <TutorialAlert
      title={t("tutorial.extensionOutdated.title")}
      className={className}
    >
      {isSafariMobile ? (
        <p className="text-sm leading-5 text-dark-secondary">
          <Trans
            ns="clubImport"
            i18nKey="tutorial.extensionOutdated.appStore"
            components={{
              textLink: (
                <a
                  href={IOS_CLUB_IMPORT_APP_URL}
                  target="_blank"
                  rel="noreferrer"
                  className="underline text-primary-action-default"
                />
              ),
            }}
          />
        </p>
      ) : (
        <>
          <p className="text-sm leading-5 text-white">
            {t("tutorial.extensionOutdated.desktop")}
          </p>
          <p className="text-sm leading-5 text-dark-secondary">
            {chromeDesktopUpdateHint}
          </p>
        </>
      )}
    </TutorialAlert>
  );
};
